var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#98A7AE",
    d: "M52 14.336c0 3.825-2.715 7.3-7.141 9.868-4.737 2.752-11.435 4.468-18.859 4.468-14.36 0-26-6.418-26-14.336S11.64 0 26 0c3.36 0 6.572.351 9.521.991v.001C45.171 3.086 52 8.272 52 14.336z",
    transform: "translate(-685.000000, -995.000000) translate(96.000000, 923.000000) translate(589.500000, 72.000000) translate(9.000000, 21.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B888E",
    d: "M52 14.336c0 3.825-2.715 7.3-7.141 9.868-1.878-3.91-3.946-8.66-3.946-10.638 0-3.626-1.944-11.658-5.392-12.574C45.171 3.086 52 8.272 52 14.336z",
    transform: "translate(-685.000000, -995.000000) translate(96.000000, 923.000000) translate(589.500000, 72.000000) translate(9.000000, 21.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332F41",
    d: "M50.027 19.824C46.121 25.018 36.834 28.672 26 28.672c-10.834 0-20.12-3.654-24.027-8.848 3.906-5.196 13.193-8.85 24.027-8.85 10.834 0 20.12 3.654 24.027 8.85z",
    transform: "translate(-685.000000, -995.000000) translate(96.000000, 923.000000) translate(589.500000, 72.000000) translate(9.000000, 21.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.7fa92512.svg";
export { ForwardRef as ReactComponent };